import React,{useState} from 'react';
import { makeStyles } from "@material-ui/core/styles";
import {Card,CardContent,Box} from "@material-ui/core";
import NumberFormat from 'react-number-format';
const useStyles = makeStyles((theme) => ({
    card:{
        height:'4.1rem',
        width:130,
        // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
    },
    card2:{
        height:'4.1rem',
        width:230,
       // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
      },
    card3:{
        height:'4.1rem',
        width:180,
        // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
    },
    titulo:{
        //color:'#4a4a4a',
        textAlign:'center',
        marginTop:'-.4rem',
        fontSize:'1rem',
        fontWeight:600
    },
    tituloColor:{

        //color:'white',
        textAlign:'center',
        marginTop:'-.6rem',
        fontSize:'1.2rem',
        fontWeight:600
    },
    subtitulo:{
        //color:'#4a4a4a',
        textAlign:'center',
        marginTop:'-1.4rem',
        fontSize:'.8rem',
    },
    subtituloCard:{
       // color:'#4a4a4a',
        textAlign:'center',
        marginTop:'.28rem',
        fontSize:'1.1rem',
    },
}));


export default function CardTotal({valor}){
    const classes = useStyles();
    const[total,setTotal]= useState([])
    const auxColor=process.env.REACT_APP_Fondo_Color
    React.useEffect(()=>{
      
        const Accesos=valor.Accesos
        const SolicitudTot=valor.SolicitudTot 
        const TareaTot=valor.TareaTot               
           
        const filtro=valor.SolicitudStatus.filter((elemento)=> elemento.Nom ==="Completo")
        const auxSolCompleto=filtro.length!==0 ? filtro[0].Total :0      
        const filtro2=valor.TareaStatus.filter((elemento)=> elemento.Nom ==="Completo")
        const auxTareaCompleto=filtro2.length!==0 ? filtro2[0].Total :0      
        setTotal({
            solCompleto:auxSolCompleto, SolicitudTot:SolicitudTot,                                    
            TareaTot:TareaTot,  TareaCompleto:auxTareaCompleto
        })
    },[valor])  

    function generarCards2(mensaje,datGen,datTot,auxColor){
        return( 
        <CardContent>
            <Card className={classes.tituloColor} 
                style={{backgroundColor:auxColor,color:'white'}} 
            >                
                <NumberFormat value={datGen} displayType={'text'}  thousandSeparator={true}/>
                {' / '}
                <NumberFormat value={datTot} displayType={'text'}  thousandSeparator={true}/>
            </Card>
            <p className={classes.subtituloCard} >
                {mensaje}
            </p>
        </CardContent>
        )
    }
  
    const totAv=total.length!==0 ?  (total.gralAv / total.gralMeta) * 100:0
    return (         
    <Box display="flex" flexDirection="row"  ml={1} >   
        {total.length!==0 ? 
        <Box display="flex" flexDirection="row"> 
            <Card className={classes.card}>
                {generarCards2(<span>Solicitudes </span>
                ,total.solCompleto, total.SolicitudTot, auxColor)}
            </Card>   
            <Card className={classes.card}>
                {generarCards2('Expedientes', total.TareaCompleto, total.TareaTot, auxColor)}
            </Card>                                              
   
      
        </Box>   
        :null}
    </Box>
    );
}
 